<div class="token-validate" [nbSpinner]="loading">
    <p class="token-sent-message">
        {{ "TOKEN-VALIDATE.TOKEN-SENT.1" | translate }}
        <strong>{{ "TOKEN-VALIDATE.TOKEN-SENT.2" | translate }}</strong> {{ "TOKEN-VALIDATE.TOKEN-SENT.3" | translate }}
        <strong>{{ (typeSending == 1 ? "REGISTER.EMAIL-ADDRESS" : "USER.CELLULAR") | translate }}</strong>
    </p>
    <form>
        <p class="paragraph-2 text-center">{{ "TOKEN-VALIDATE.WRITE-TOKEN" | translate }}</p>
        <div class="row small-gutter justify-content-center mt-2 mb-2">
            <div class="col-2" *ngFor="let input of [0, 1, 2, 3, 4]">
                <input
                    nbInput
                    name="token-{{ input }}"
                    id="input-token-{{ input }}"
                    placeholder="X"
                    type="tel"
                    mask="0"
                    maxlength="1"
                    fullWidth
                    [value]="tokenControl.input[input]"
                    (keydown)="inputHandler($event, input)"
                    required
                    #inputToken
                />
            </div>
        </div>
    </form>
    <span class="caption-1 mb-4 mt-4">{{ "TOKEN-REQUEST.TIMER-SMS" | translate }}</span>
    <button nbButton [disabled]="receiveSmsDisabled" (click)="onRequestTokenViaSMS()">
        {{ "TOKEN-REQUEST.GET-BY-SMS" | translate }}{{ countdown > 0 ? "(" + countdown + ")" : "" }}
        <nb-icon icon="smartphone-outline"></nb-icon>
    </button>

    <button
        nbButton
        fullWidth
        status="success"
        class="mt-4"
        [disabled]="!tokenControl.valid"
        (click)="onValidateToken()"
    >
        {{ "BUTTONS.VALIDATE" | translate }} <nb-icon icon="checkmark-circle-outline"></nb-icon>
    </button>
</div>
